//@ts-check
export { default } from './Tree';